import { Modal, PrimaryButton } from '@common/components';
import { Button } from 'antd';
import { Colors } from 'works/legacy/lib/style-helper';
import React from 'react';

type Props = {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ConfirmationModal({ visible, onCancel, onConfirm }: Props) {
  return (
    <>
      <Modal
        className="integration-form__shift-ingestion-active__modal"
        title="Are you sure you want to turn off shift ingestion?"
        visible={visible}
        footer={[
          <Button
            key="cancel"
            onClick={onCancel}
            style={{ borderColor: Colors.steel }}
          >
            Cancel
          </Button>,
          <PrimaryButton
            key="switch_off"
            onClick={onConfirm}
            style={{ backgroundColor: Colors.coral, borderColor: Colors.coral }}
          >
            Turn Off Shift Ingestion
          </PrimaryButton>,
        ]}
      >
        <p className="integration-form__shift-ingestion-active__modal__description">
          Turning off shift ingestion will cancel all ingested shifts.
        </p>
      </Modal>
      <style jsx>{`
        .integration-form__shift-ingestion-active__modal__description {
          color: ${Colors.midnightLighter};
          font-weight: 350;
          font-size: 16px;
          line-height: 20px;
          margin: 0;
        }
      `}</style>
    </>
  );
}
